/* eslint-disable global-require */

// 国际化竞价投放产品枚举
import _ from 'lodash';
import tool from 'src/utils/tool';
import {
  isVigoWhite, tbnrWhite, whiteValue, isSupportPangleImage, isDpaPangleWhite,
} from 'src/const/whiteList';

import {
  TopbuzzLanguages,
  tiktokLanguages,
  tiktokAdNetworkLanguages,
  HeloLanguages,
} from 'src/const/language';

import { campaignObjectiveValue } from 'src/const/state/campaign';
import store from 'src/store';


export const INVENTORY_FLOW = { // 版位顺序和INVENTORY_FLOW_MAP一致
  ALL: 0,
  TIKTOK: 3000,
  TOPBUZZ: 1000,
  VIGO: 2000,
  HELO: 4000,
  TIKTOKADNETWORK: 9000,
  OTHER: -1,
};

// 需要增加placement flow rit 检查的列表
export const CHECK_PLACEMENT_FLOW = [
  INVENTORY_FLOW.VIGO,
  INVENTORY_FLOW.TIKTOKADNETWORK,
  INVENTORY_FLOW.HELO,
];

/**
 * 效果广告的投放流量
 * key: inventory flow 的 key，用于前后端区分选择的产品类型
 * name: ---
 * label: 产品多语言名称的 key
 * value: inventory_type 的 list
 * productLine: ---
 * languages: 支持投放的语言
 * icon: 产品图标，引用方法：<img :src="item.icon">
 * availableCountries: 开放国家
 * supportImageType：支持的图片类型，对应具体的属性在 src/const/state/creative 中的 imageTemplate 里
 */
export const INVENTORY_FLOW_MAP = {
  ALL: {
    key: INVENTORY_FLOW.ALL,
    name: 'All Apps',
    label: 'placement_all_apps', // 翻译key
    productLine: 'all',
    languages: [],
    icon: require('../../assets/images/placement-tb.png'),
    availableCountries: [],
    isSupportQrcodePreview: false,
    supportImageType: () => [],
  },
  TIKTOK: {
    key: INVENTORY_FLOW.TIKTOK,
    name: 'TikTok',
    label: 'placement_tiktok',
    // tiktok + musical
    productLine: 'tiktok',
    languages: [...tiktokLanguages],
    icon: require('../../assets/images/placement-tt.png'),
    show: true,
    // 'CA', 'IL', 'PL', 'HK' 这几个在小流量
    availableCountries: ['JP', 'TW', 'IN', 'KR', 'TH', 'MY', 'ID', 'VN', 'RU', 'TR'],
    isSupportQrcodePreview: true, // 是否支持二维码预览
    supportImageType: () => [],
  },
  TOPBUZZ: {
    key: INVENTORY_FLOW.TOPBUZZ,
    name: 'Babe&BuzzVideo',
    label: 'placement_news_feed_app',
    productLine: 'topbuzz',
    languages: [...TopbuzzLanguages],
    icon: require('../../assets/images/placement-tb.png'),
    show: true,
    availableCountries: ['US', 'BR', 'JP', 'TW', 'KR'],
    isSupportQrcodePreview: false, // 是否支持二维码预览
    supportImageType: () => ['HORIZONTAL'],
  },
  VIGO: { // cheng
    key: INVENTORY_FLOW.VIGO,
    name: 'Vigo',
    label: 'placement_vigo',
    productLine: 'vigo',
    languages: ['en'],
    icon: require('../../assets/images/placement-vigo.png'),
    show: isVigoWhite(),
    // 可投放的国家
    availableCountries: ['IN'],
    isSupportQrcodePreview: false, // 是否支持二维码预览
    supportImageType: () => ['HORIZONTAL', 'VERTICAL'],
  },
  HELO: {
    key: INVENTORY_FLOW.HELO,
    name: 'Helo',
    label: 'placement_helo',
    productLine: 'Helo',
    languages: HeloLanguages,
    icon: require('../../assets/images/placement-helo.png'),
    show: true,
    availableCountries: ['IN'],
    isSupportQrcodePreview: false, // 是否支持二维码预览
    supportImageType: () => ['HORIZONTAL', 'SQUARE'],
  },
  TIKTOKADNETWORK: {
    key: INVENTORY_FLOW.TIKTOKADNETWORK,
    name: 'Pangle',
    label: 'placement_tiktok_ad_network',
    // 穿山甲
    productLine: 'TikTokAdNetwork',
    languages: [...tiktokAdNetworkLanguages],
    icon: require('../../assets/images/placement-new-pangle.png'),
    show: true,
    availableCountries: ['JP', 'KR', 'TW'], // 穿山甲只对日本开放，韩国小流量
    isSupportQrcodePreview: false, // 是否支持二维码预览
    supportImageType: () => {
      const isDpa = store.getters['creative/create'];
      return isSupportPangleImage(isDpa) ? ['HORIZONTAL', 'SQUARE', 'VERTICAL_720P'] : [];
    },
  },
};
// 数据披露other,,排查了一下代码，太多地方用到INVENTORY_FLOW_MAP，好多还是直接object.keys和entrys,
// 实在不敢在原有的配置上加other,,后续新增版位和流量记得同步更新这个配置
export const dashboardPlacement = {
  TIKTOK: {
    key: INVENTORY_FLOW.TIKTOK,
    name: 'TikTok',
    label: 'placement_tiktok',
    color: '#01d6db', // dashboard版位的颜色
    icon: require('../../assets/images/placement-tt.png'),
    show: () => true,
  },
  TOPBUZZ: {
    key: INVENTORY_FLOW.TOPBUZZ,
    name: 'Babe&BuzzVideo',
    label: 'placement_news_feed_app',
    color: '#629BFE',
    icon: require('../../assets/images/placement-tb.png'),
    show: () => true,
  },
  VIGO: { // cheng
    key: INVENTORY_FLOW.VIGO,
    name: 'Vigo',
    label: 'placement_vigo',
    color: '#F45858',
    icon: require('../../assets/images/placement-vigo.png'),
    show: () => isVigoWhite(),
  },
  HELO: {
    key: INVENTORY_FLOW.HELO,
    name: 'Helo',
    label: 'placement_helo',
    color: '#ffc53d',
    icon: require('../../assets/images/placement-helo.png'),
    show: () => true,
  },
  TIKTOKADNETWORK: {
    key: INVENTORY_FLOW.TIKTOKADNETWORK,
    name: 'Pangle',
    label: 'placement_tiktok_ad_network',
    color: '#2a4d8f',
    icon: require('../../assets/images/placement-new-pangle.png'),
    show: () => true,
  },
  OTHER: {
    key: INVENTORY_FLOW.OTHER,
    name: 'OTHER',
    label: 'placement_other',
    color: '#66c23a',
    show: () => true,
  },
};

// 版位预览图配置
export const FLOW_VIEWER_LIST = [
  {
    flow: INVENTORY_FLOW.TIKTOK,
    label: 'placement_tt_view',
    num: 0,
    value: require('../../assets/images/placement-tt-view-new.png'),
    position: 0, // 数组的初始位置，有得在计算中隐藏，
  },
  {
    flow: INVENTORY_FLOW.TIKTOK,
    label: 'placement_tt_view',
    num: 1,
    value: require('../../assets/images/placement-tt-search-ads.png'),
    position: 9, // 数组的初始位置，有得在计算中隐藏，
  },
  {
    flow: INVENTORY_FLOW.TOPBUZZ,
    label: 'placement_news_feed_view',
    num: 1,
    value: require('../../assets/images/placement-tnb-view1-new.png'),
    position: 1,
  },
  {
    flow: INVENTORY_FLOW.TOPBUZZ,
    label: 'placement_news_feed_view',
    num: 2,
    value: require('../../assets/images/placement-tnb-view2-new.png'),
    position: 2,
  },
  {
    flow: INVENTORY_FLOW.TOPBUZZ,
    label: 'placement_news_feed_view',
    num: 3,
    value: require('../../assets/images/placement-tnb-view3-new.png'),
    position: 3,
  },
  {
    flow: INVENTORY_FLOW.VIGO,
    label: 'placement_vigo_view',
    num: 1,
    value: require('../../assets/images/placement-vigo-view1.png'),
    position: 4,
  },
  {
    flow: INVENTORY_FLOW.VIGO,
    label: 'placement_vigo_view',
    num: 2,
    value: require('../../assets/images/placement-vigo-view2.png'),
    position: 5,
  },
  {
    flow: INVENTORY_FLOW.HELO,
    label: 'placement_helo_view',
    num: 1,
    value: require('../../assets/images/placement-helo-view-new.png'),
    position: 7,
  },
  {
    flow: INVENTORY_FLOW.HELO,
    label: 'placement_helo_view',
    num: 2,
    value: require('../../assets/images/placement-helo-view-immersion-new.png'),
    position: 8,
  },
  {
    flow: INVENTORY_FLOW.TIKTOKADNETWORK,
    label: 'placement_tiktok_ad_network_view',
    num: 0,
    value: require('../../assets/images/tiktok-ad-network-view-new.png'),
    position: 6,
  },
];


export const flowValueToKey = () => {
  const result = {};
  Object.entries(INVENTORY_FLOW_MAP).forEach(([key, item]) => {
    if (key === 'ALL') {
      return;
    }
    result[item.key] = key;
  });

  return result;
};

export const imageFlowTypes = () => {
  const result = [];
  Object.entries(INVENTORY_FLOW_MAP).forEach(([key, item]) => {
    if (item.supportImageType().length > 0) {
      result.push(item.key);
    }
  });
  return result;
};

// 0=automitc 1=select placement
export const FLOW_TYPE = {
  AUTO: 0,
  SELECT: 1,
};

// 效果广告的投放流量INVENTORY_FLOW=>obj
export const INVENTORY_FLOW_REVERSE_MAP = {};
Object.keys(INVENTORY_FLOW_MAP).forEach((kk) => {
  const obj = INVENTORY_FLOW_MAP[kk];
  INVENTORY_FLOW_REVERSE_MAP[obj.key] = obj;
});
export const BrandSafetyPartnerType = {
  OpenSlate: 1,
  IAS: 2,
};

// 需要进行placement rit 白名单列表函数
export const NeedCheckFlow = (flowID = 0) => CHECK_PLACEMENT_FLOW.indexOf(flowID) >= 0;

/**
 * placement rit 判断函数，收敛到统一的判断函数
 * @param flowId , flow key ID 例如 3000
 * @param opts, 函数参数 例如{objective_type, user...}
 * @return {boolean} 命中白名单返回true,否则false
 * @constructor
 */
export const CheckEffectivePlacement = (flowId = 0, opts = {}) => {
  const objective_type = +(opts.objective_type);
  let valid = false; // 验证有效位true,否则false;
  if (flowId === INVENTORY_FLOW.TIKTOKADNETWORK) {
    // 穿山甲只支持应用安装+ Conversion + Traffic
    if (
      objective_type === campaignObjectiveValue.Traffic ||
      objective_type === campaignObjectiveValue.AppInstall ||
      objective_type === campaignObjectiveValue.Conversion ||
      objective_type === campaignObjectiveValue.DPA && isDpaPangleWhite() // DPA广告需要有dpa-pangle白名单才允许投放pangle
    ) {
      valid = true;
    }
  } else if (flowId === INVENTORY_FLOW.VIGO) {
    valid = isVigoWhite();
    // console.log(`${flowId} ===>isVigoWhite ${isVigoWhite()}`);
  } else if (flowId === INVENTORY_FLOW.HELO) {
    valid = true;
  }
  // console.log(`${flowId} ===>valida:${valid} ${JSON.stringify(opts)}`);
  return valid;
};


export class GenerateInventory {
  constructor(args = {}) {
    const urlParams = tool.queryToJson() || {};
    const opts = _.extend({}, urlParams, args);
    this.inventoryFlowMap = { ...INVENTORY_FLOW_MAP };
    this.inventoryFlowReverseMap = { ...INVENTORY_FLOW_REVERSE_MAP };
    this.inventoryFlowList = [];// all flow list
    this.opts = opts;
    this.generateInventoryFlow(opts);
  }

  generateInventoryFlow(opts = {}) {
    // 特殊白名单
    const objective_type = +(opts.objective_type);
    const inventoryFlowList = []; // reset flow list
    const inventoryFlowMap = { ...INVENTORY_FLOW_MAP };
    const allKey = 'ALL';
    let allItem = { ...INVENTORY_FLOW_MAP[allKey] }; // 原始
    const mergeItem = (item = {}, flowItem = {}) => {
      const itemLanguage = item.languages || [];
      const itemCountry = item.availableCountries || [];
      item.languages = Array.from(new Set(itemLanguage.concat(flowItem.languages || [])));
      item.availableCountries = Array.from(new Set(itemCountry.concat(flowItem.availableCountries || [])));
      return item;
    };

    // 逐个单项白名单检查，languages，countries, rit
    Object.keys(inventoryFlowMap).forEach((key) => {
      const item = inventoryFlowMap[key];
      if (key === 'TOPBUZZ') {
        Object.keys(tbnrWhite).forEach((key) => {
          // tbnr白名单
          const whiteItem = tbnrWhite[key];
          const itemLanguage = item.languages;
          const itemCountry = item.availableCountries;
          const white_value = window.WHITE_LIST_OBJECT?.white_value || [];
          if (white_value.indexOf(whiteValue[key]) >= 0) {
            item.languages = Array.from(new Set(itemLanguage.concat(whiteItem.language || [])));
            item.availableCountries = Array.from(new Set(itemCountry.concat(whiteItem.country || [])));
          }
        });
      }
      this.inventoryFlowMap[key] = item;
      this.inventoryFlowReverseMap[item.key] = item;
    });

    // 计算总的ALL项及全部有效的inventoryFlowList
    Object.keys(this.inventoryFlowMap).forEach((key) => {
      const item = this.inventoryFlowMap[key];
      const flowId = Number(item.key || 0);

      if (key !== 'ALL') {
        if (NeedCheckFlow(flowId)) {
          if (CheckEffectivePlacement(flowId, { name: item.name, objective_type, inventory_flow_type: FLOW_TYPE.AUTO })) {
            allItem = mergeItem(allItem, item);
            this.inventoryFlowMap[allKey] = allItem;
            this.inventoryFlowReverseMap[allItem.key] = allItem;
            inventoryFlowList.push(flowId);
          }
        } else {
          this.inventoryFlowMap[allKey] = allItem;
          this.inventoryFlowReverseMap[allItem.key] = allItem;
          inventoryFlowList.push(flowId);
        }
      }
    });
    this.inventoryFlowList = inventoryFlowList;
  }
}
